import React, { Fragment, FC, useState } from 'react';
import { Button, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import DeleteIcon from '@material-ui/icons/Delete';

import { useAdminUpdateClientMutation } from 'api';
import { useProtectedClient, useNotify } from 'hooks';
import { Alert } from 'components';
import { useDeleteContentDomain } from 'features/admin/updaters';

interface IProps {
  contentDomain: string;
}

const DeleteContentDomain: FC<IProps> = ({ contentDomain }) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  const notify = useNotify();
  const { id, content_domains } = useProtectedClient();
  const mutationOptions = useDeleteContentDomain();
  const { mutate } = useAdminUpdateClientMutation({
    onSuccess: () => notify.info({ message: t('admin:deleteContentDomainSuccess') }),
    ...mutationOptions,
  });

  function handleDelete() {
    setOpen(false);
    const domainsToRetain = content_domains.filter(domain => domain !== contentDomain);

    mutate({
      data: { id, content_domains: domainsToRetain },
    });
  }

  return (
    <Fragment>
      <Button color="inherit" variant="text" onClick={() => setOpen(true)} endIcon={<DeleteIcon />}>
        <Typography>{t('common:delete')}</Typography>
      </Button>
      <Alert
        open={open}
        onConfirm={handleDelete}
        onCancel={() => setOpen(false)}
        message={t('admin:deleteContentDomainMessage')}
        confirm={t('common:delete')}
      />
    </Fragment>
  );
};

export default DeleteContentDomain;
